export const generateSkillsData = (jobs, projects, skillCategories) => {
  const skillsMap = new Map();

  const initializeSkill = (skillName) => {
    if (!skillsMap.has(skillName)) {
      skillsMap.set(skillName, {
        name: skillName,
        weightedScore: 0,
        occurrences: 0,
        relatedTo: {
          projects: [],
          jobs: [],
        },
        lastUsed: 0,
      });
    }
  };

  // Process jobs and projects (unchanged)
  jobs.forEach((job) => {
    job.technologies.forEach((tech) => {
      initializeSkill(tech);
      const skill = skillsMap.get(tech);
      skill.weightedScore += job.weight;
      skill.occurrences += 1;
      skill.lastUsed = Math.max(skill.lastUsed, job.weight);
      if (!skill.relatedTo.jobs.includes(job.id)) {
        skill.relatedTo.jobs.push(job.id);
      }
    });
  });

  projects.forEach((project) => {
    project.technologies.forEach((tech) => {
      initializeSkill(tech);
      const skill = skillsMap.get(tech);
      skill.weightedScore += project.weight;
      skill.occurrences += 1;
      if (!skill.relatedTo.projects.includes(project.id)) {
        skill.relatedTo.projects.push(project.id);
      }
    });
  });

  const calculateSkillLevel = (skill) => {
    // Slightly higher base score multiplier
    const baseScore = skill.weightedScore * 1.25;

    // Slightly higher frequency impact
    const frequencyImpact = Math.log2(skill.occurrences + 1) * 0.5;

    // Slightly higher job diversity
    const jobCount = skill.relatedTo.jobs.length;
    const jobDiversityBonus = jobCount * 0.4;

    // Slightly higher project diversity
    const projectCount = skill.relatedTo.projects.length;
    const projectDiversityBonus = projectCount * 0.3;

    // Slightly higher recency
    const recencyBonus = skill.lastUsed * 0.7;

    // Calculate raw score
    const rawScore =
      baseScore +
      frequencyImpact +
      jobDiversityBonus +
      projectDiversityBonus +
      recencyBonus;

    // Slightly higher scaling
    const scaledScore = Math.log2(rawScore + 1) * 13;

    // Scale to 50-95 range with slightly higher base
    const finalScore = Math.min(95, Math.max(50, Math.round(54 + scaledScore)));

    // Debug logging
    console.log(`Skill: ${skill.name}`);
    console.log(
      `  Base Score (${skill.weightedScore} × 1.35): ${baseScore.toFixed(2)}`
    );
    console.log(
      `  Frequency (${skill.occurrences}): ${frequencyImpact.toFixed(2)}`
    );
    console.log(
      `  Job Diversity (${jobCount}): ${jobDiversityBonus.toFixed(2)}`
    );
    console.log(
      `  Project Diversity (${projectCount}): ${projectDiversityBonus.toFixed(
        2
      )}`
    );
    console.log(`  Recency (${skill.lastUsed}): ${recencyBonus.toFixed(2)}`);
    console.log(`  Raw Score: ${rawScore.toFixed(2)}`);
    console.log(`  Scaled Score: ${scaledScore.toFixed(2)}`);
    console.log(`  Final Score: ${finalScore}`);
    console.log("------------------------");

    return finalScore;
  };

  return Object.entries(skillCategories).map(([category, techs]) => ({
    category,
    items: techs
      .filter((tech) => skillsMap.has(tech))
      .map((tech) => {
        const skillData = skillsMap.get(tech);
        return {
          name: tech,
          level: calculateSkillLevel(skillData),
          relatedTo: skillData.relatedTo,
          usage: {
            projectCount: skillData.relatedTo.projects.length,
            jobCount: skillData.relatedTo.jobs.length,
            totalUses: skillData.occurrences,
            weightedScore: skillData.weightedScore,
          },
        };
      })
      .sort((a, b) => b.level - a.level),
  }));
};
